import React, {useEffect, useState} from "react";


import isEmail from 'validator/lib/isEmail';


import SectionContainerComponent from "@Components/Sections/SectionContainer";


import iconMailL from "@Icons/SVG/icon-mail-l-white.svg";
import iconSearchL from "@Icons/SVG/icon-search-l-white.svg";
import iconDollarL from "@Icons/SVG/icon-dollar-l-white.svg";


import iconCheckBox from "@Icons/SVG/icon-check_box.svg";
import iconMail from "@Icons/SVG/icon-mail-lg.svg";
import iconLoop from "@Icons/SVG/icon-search-lg.svg";
import iconDollar from "@Icons/SVG/icon-dollar-lg.svg";
import iconSecurity from "@Icons/SVG/icon-security-m.svg";
import iconVisibilittyOff from "@Icons/SVG/icon-visibility_off-m.svg";
import iconStarHalf from "@Icons/SVG/icon-star_half-m.svg";
import iconComposite from "@Icons/SVG/icon-composite-m.svg";


import "./index.scss";
import {Col, Row} from "react-bootstrap";
import {ReactSVG} from "react-svg";
import HeaderComponent from "@Components/Elements/TextElements/Header";
import FormComponent from "@Components/Forms/@Form";
import {ButtonComponent, InputComponent} from "@Components/Forms";

import HomePageSignUpSection from "@Pages/@HomePage/SignUpSection";
import {CardComponent} from "@Components/Elements";


import aboutUsImage from "@Pages/@HomePage/@@Images/about-us.png";
import headImage from "./@@Images/headImage.svg";
import headSectionImage from "@Pages/@HomePage/@@Images/headSectionImage.svg";
import BadgeCardComponent from "@Components/Elements/Cards/BadgeType";
import {PageContainerComponent} from "@Components/Sections";
import {HeadSectionComponent} from "../../Parts/Sections";
import HomePageHowItWorksSection from "@Pages/@HomePage/HowItWorks";
import HomePageRecoveryEngineSection from "@Pages/@HomePage/RecoveryEngine";
import HomePageSecuritySection from "@Pages/@HomePage/Security";
import {UseQyvoUser} from "@Store/@Hooks";


export const HomePage:React.FC = () => {


    const QyvoUser = UseQyvoUser();


    const headSectionTitle = `
        <span>If It's Refundable,</span><br/>We'll Find It.
    `;

    const headSectionSubText = `
        <p>Qyvo finds refund opportunities, so you don't have to.</p>
        <p>Turn missed dollars into found money—automatically. Qyvo's C.A.R.E. combs your inbox, files every claim, and wins refunds on flights, subscriptions, and hidden fees while you relax.</p>
    `;


    return (
        <PageContainerComponent pageType={'home'}>

            <HeadSectionComponent
                pageName={'home-page'}
                sectionHeaderText={headSectionTitle}
                sectionSubText={headSectionSubText}
                sectionImage={headImage}
            >

                {!QyvoUser &&
                <ButtonComponent
                    type={'primary'}
                    text={'Start getting refunds'}
                    href={'/join-qyvo'}
                    size={'l'}
                />
                }

                <ButtonComponent
                    type={'secondary'}
                    text={'See how it works'}
                    href={'/how-it-works'}
                    size={'l'}
                />

            </HeadSectionComponent>

            <HomePageHowItWorksSection />

            <HomePageRecoveryEngineSection />

            <HomePageSecuritySection />

            {!QyvoUser &&
            <HomePageSignUpSection />
            }

        </PageContainerComponent>
    );

};


export default HomePage;
